const featuredBlogs = [
  {
    image: "",
    imageURL: "https://boloforms.ghost.io/content/images/2025/07/ChatGPT-Image-Jul-2--2025--05_49_16-PM.png",
    title: "The 5 Best AI Contract Review Software Tools for 2025",
    genreColor: "bg-red-100",
    genre: "CLM",
    date: "Jul 21, 2025",
    blogUrl:
      "https://www.bolosign.com/blog/the-5-best-ai-contract-review-software-tools-for-2025/",
    desc: "Compare the best AI contract review tools for 2025. See features, benefits, and practical tips to implement them at scale. Explore BoloSign’s unified solution.",
    owner: {
      img: "https://i.imgur.com/CbNehZg.png",
      name: "Paresh Deshmukh",
      title: "Co-Founder, BoloSign",
    },
  },
  {
    image: "",
    imageURL:"https://boloforms.ghost.io/content/images/2025/07/ChatGPT-Image-Jul-4--2025--05_10_14-PM.png",
    title: `Are Clickwrap Agreements Legally Binding?`,
    genreColor: "bg-green-100",
    genre: "CLM",
    date: "Jul 21, 2025",
    blogUrl:
      "https://www.bolosign.com/blog/are-clickwrap-agreements-legally-binding/",
    desc: "Learn if clickwrap agreements are legally binding, how they work, and key best practices for enforceability.",
    owner: {
      img: "https://i.imgur.com/CbNehZg.png",
      name: "Paresh Deshmukh",
      title: "Co-Founder, BoloSign",
    },
  },
];

export { featuredBlogs };
